import baseUrl from './baseurl'
export const evaluationUrl = baseUrl + '/ttd-fund-question'
export const investorUrl = baseUrl + '/ttd-fund-user'
export const productUrl = baseUrl + '/ttd-fund-order'
export const msgBaseUrl = baseUrl + '/message-service'

export const resUrl = {
  evaluation: '/question/new/list',
  evaluationCal: '/evaluation/calculation',
  evaluationSave: '/evaluation/save',
  investorPersonal: '/personalInvenstem/getBaseInfo',
  investorAgency: '/orgInvenstem/getBaseInfo',
  investorProduct: '/productInvenstement/getProductInvenstement',
  evaluationUpdate: '/evaluation/updateResult',
  idAuth: '/author/idcardAuthor',
  idAuthOther: '/author/addInvenstemIdCardAuthor',
  record: '/evaluation/getUserEvaluationResult',
  productList: '/order/no/match',
  loginApp: '/userInfo/investorLogin',
  msgReady: '/ms/read',

  needSignTest: '/parm/sginQuestion',
  setEvaluationResultFileSign: '/evaluation/setEvaluationResultFileSign',
  uploadBaseStrFile: '/oos/uploadBase64',

  questionNewList: '/question/new/list' // 问卷、问题列表
}

export const phone = '400-688-9268'




// WEBPACK FOOTER //
// ./src/api/config.js